import React, { lazy, Suspense, useContext } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import ErrorBoundary from "./components/errorBoundary/ErrorBoundary";
import { StoreContext } from "./components/ContextStore/StoreContextProvider";
const LandingPage = lazy(() =>
  import("./components/LandingHomePage/LandingPage/LandingPage")
);
const LoginPage = lazy(() => import("./components/login/LoginMainPage/Login"));
const FirstLogin = lazy(() =>
  import("./components/login/Firstlogin/Firsttime")
);
const ForgotPasswordPage = lazy(() =>
  import("./components/ForgotPassword/forgotPassword")
);
const ManageCohorts = lazy(() =>
  import("./components/ManageCohorts/ManageCohorts")
);
const CohortWizardContainer = lazy(() =>
  import("./components/CohortWizardContainer/CohortWizardContainer")
);
const EnrichCoupon = lazy(() =>
  import("./components/EnrichCoupon/EnrichCoupon")
);
const PromoUtilisationTracking = lazy(() =>
  import("./components/PromoUtilisationTracking/PromoUtilisationTracking/PromoUtilisationTracking")
);
const ImpactOnBusiness = lazy(() =>
  import("./components/ImpactOnBusiness/ImpactOnBusiness/ImpactOnBusiness")
);
const LeadershipView = lazy(() =>
  import("./components/LeadershipView/LeadershipView")
);
const UserAccessManagementLanding = lazy(() =>
  import("./components/UserAccessManagementLanding/UserAccessManagementLanding/UserAccessManagementLanding")
);

const Routes = () => {
  const { userDetails } = useContext(StoreContext);
  
  // Only evaluate access guards once userDetails is loaded to avoid redirect loop
  const isUserDataLoaded = !!userDetails?.email;
  const magnifAiAccess = userDetails?.accessToMagnifAi?.toLowerCase();
  const magnifyAccessLevel = userDetails?.magnifyAccessLevel?.toLowerCase();
  const hasMagnifAiAccess = magnifAiAccess === "yes";
  const isCreateCohortAllowed = ["super user", "creator"].includes(magnifyAccessLevel);
  const isUserAccessManagementAllowed = magnifyAccessLevel === "super user";
  const isManageCohortsAllowed = magnifyAccessLevel !== "view only";
  const canAccessCohortWizard = isUserDataLoaded && hasMagnifAiAccess && isCreateCohortAllowed;
  const canAccessUserAccessManagement = isUserDataLoaded && hasMagnifAiAccess && isUserAccessManagementAllowed;

  return (
    <ErrorBoundary>
      <Suspense fallback={<p>Loading...</p>}>
        <Switch>
          <Route exact path={"/login"} component={LoginPage} />
          <Route exact path={"/signup"} component={FirstLogin} />
          <Route exact path={"/forgotpassword"} component={ForgotPasswordPage} />
          <Route
            exact
            path={"/managecohorts"}
            render={() =>
              !isUserDataLoaded ? <p>Loading...</p> : isManageCohortsAllowed ? <ManageCohorts /> : <Redirect to="/landingscreen" />
            }
          />
          <Route
            exact
            path={"/createcohort"}
            render={() =>
              !isUserDataLoaded ? <p>Loading...</p> : canAccessCohortWizard ? <CohortWizardContainer /> : <Redirect to="/landingscreen" />
            }
          />
          <Route
            exact
            path={"/previewcohort"}
            render={() =>
              !isUserDataLoaded ? <p>Loading...</p> : canAccessCohortWizard ? <CohortWizardContainer /> : <Redirect to="/landingscreen" />
            }
          />
          <Route
            exact
            path={"/setupcohortparameter"}
            render={() =>
              !isUserDataLoaded ? <p>Loading...</p> : canAccessCohortWizard ? <CohortWizardContainer /> : <Redirect to="/landingscreen" />
            }
          />
          <Route
            exact
            path={"/enrich"}
            render={() =>
              !isUserDataLoaded ? <p>Loading...</p> : isManageCohortsAllowed ? <EnrichCoupon /> : <Redirect to="/landingscreen" />
            }
          />
          <Route
            exact
            path={"/promoutilisationtracking"}
            component={PromoUtilisationTracking}
          />
          <Route exact path={"/impactonbusiness"} component={ImpactOnBusiness} />
          <Route exact path={"/leadershipview"} component={LeadershipView} />
          <Route
            exact
            path={"/useraccessmanagement"}
            render={() =>
              !isUserDataLoaded ? <p>Loading...</p> : canAccessUserAccessManagement ? (
                <UserAccessManagementLanding />
              ) : (
                <Redirect to="/landingscreen" />
              )
            }
          />
          <Route exact path={"/"} component={LandingPage} />
          <Route exact path={"/landingscreen"} component={LandingPage} />
          <Route path={"/*"} render={() => <Redirect to="/login" />} />
        </Switch>
      </Suspense>
    </ErrorBoundary>
  );
};

export default Routes;
